<script setup lang="ts">
import { computed, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useQueryClient } from '@tanstack/vue-query'
import LuckyWheelResultDialog from '@/components/raffle/LuckyWheelResultDialog.vue'
import { useNotifyStore } from '@/stores/notify'
import { highlightFreeChanceContent, parseFreeChancesFromContent } from '@/utils'

const router = useRouter()
const queryClient = useQueryClient()
const notifyStore = useNotifyStore()

const current = computed(() => notifyStore.currentLuckyWheelModal)

const visible = computed({
  get: () => !!current.value,
  set: (value) => {
    if (!value) notifyStore.dismissLuckyWheelModal()
  },
})

const customTitle = computed(() => current.value?.feed.title)
const customHighlightText = computed(() => {
  const content = current.value?.feed.content
  return content ? highlightFreeChanceContent(content) : undefined
})

const freeChances = computed(() => {
  const content = current.value?.feed.content
  return content ? parseFreeChancesFromContent(content) : 1
})

watch(current, (modal) => {
  if (!modal) return
  queryClient.invalidateQueries({ queryKey: ['lucky-wheel-home'] })
  queryClient.invalidateQueries({ queryKey: ['member-activities'] })
})

const closeModal = () => {
  notifyStore.dismissLuckyWheelModal()
}

const handlePrimary = () => {
  closeModal()
  router.push('/activity/lucky-wheel')
}
</script>

<template>
  <LuckyWheelResultDialog
    v-if="current"
    v-model:show="visible"
    variant="free_chance"
    :free-chances="freeChances"
    :custom-title="customTitle"
    :custom-highlight-text="customHighlightText"
    @primary="handlePrimary"
  />
</template>
